import React from 'react';
import { Route, Routes as ReactRouterDomRoutes } from 'react-router-dom';
import Login from 'modules/auth/Login';
import routes from 'routes/constants/routes';
import Dashboard from 'modules/dashboard';

const Routes = () => (
  <ReactRouterDomRoutes>
    <Route path={routes.login} element={<Login />} />
    {/*<Route
      path={routes.changePassword}
      element={<ChangePassword isSeparateScreen />}
    />*/}
    <Route path={routes.dashboard} element={<Dashboard />} />
  </ReactRouterDomRoutes>
);

export default Routes;
